export default {
  fontFamily: "'Gotham Pro', Helvetica, Arial",
  colors: {
    main: '#4a4a4a',
    white: '#ffffff',
    secondary: '#9b9b9b',
    lightGray: 'rgb(215, 215, 217)',
    primary: '#7070ff',
    darkPrimary: '#8C8CFF',
    lighterPrimary: '#f0f0ff',
    border: '#e3e3e3',
    success: '#5fb3b3',
    darkSuccess: '#4b9393',
    danger: '#ee1e31',
    darkDanger: '#c61322',
    lightDanger: '#fcd1d5',
    warning: '#fed305',
    darkWarning: '#ddb800',
    lightWarning: '#fff7cd',
    mainBackground: '#f8f9fd',
    darkerBackground: '#eeeff4',
  },
};
